import React from 'react'
import { Tag, Intent, ITagProps } from '@blueprintjs/core'
import { ITicket } from '@api'

interface SourceTagProps {
  ticket: ITicket
  tagProps?: ITagProps
}

export default function ({ ticket: { source }, tagProps }: SourceTagProps) {
  if (!source || source === 'spaceiq') return null

  return (
    <Tag round minimal intent={Intent.WARNING} {...tagProps}>
      <span style={{ textTransform: 'capitalize' }}>{source}</span>
    </Tag>
  )
}
